import { createAxiosHttpClient } from '@ecommerce/http-setup';
import { createAllServices } from '@ecommerce/http-services';
import { userStorage } from '../utils/storage';

export const httpClient = createAxiosHttpClient({
  tenantName: 'mouchi',
  userStorage,
  onLogout: () => {
    userStorage.removeFromStorage();
    window.location.href = "/login";
  },
  logoutRedirectUrl: '/login',
});

const httpServices = createAllServices(httpClient);

export const HttpProduct = httpServices.products;
export const HttpCategory = httpServices.categories;
export const HttpOrder = httpServices.orders;
export const HttpAuth = httpServices.auth;
export const HttpUserClient = httpServices.userClients;
export const HttpUserAddress = httpServices.userAddresses;
export const HttpShippings = httpServices.shippings;
export const HttpCoupon = httpServices.coupons;
export const HttpPaymentOption = httpServices.payments;
export const HttpBanner = httpServices.banners;


export const syncTokensAfterLogin = (accessToken: string, refreshToken: string) => {
  httpClient.tokenStorage.save({ accessToken, refreshToken });
  httpClient.updateAuthHeader();
};

export { HttpCategoryProduct } from './httpCategoryProduct';
export { HttpCache } from './httpCache';
export { HttpMercadoPagoReturn } from './httpMercadoPagoReturn';
export { HttpSecurityObjects } from './httpSecurityObjects';
export { HttpLogger } from './httpLogger';

export { httpAxiosBase, axiosInstance, updateAxiosAuthHeader } from './httpAxiosBase';
export { HttpAxiosRequest } from './httpAxiosRequest';
